import { testMsg } from "../test-apis";
import { isTestCompany } from "../utils/auth";
import http from "../utils/http";

export const reaction = (params) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http.post("/posts/reaction", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getReactions = (postType, postIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http.get(`/posts/reaction/${postType}/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};